export const GoFurtherConstants = {
  Title: "EV稼働・営収向上",
} as const;
